import { BlackListKeywords } from "@/models/crawler.model";
import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class CrawlerRest {
  private baseUrl: string = "/crawler";

  getIndexedVideos(params?: QueryParams): Observable<any> {
    const url: string = `/keywords`;
    return api.get(url, params);
  }

  getKeywords(
    transcriptId: string,
    params: Omit<QueryParams, "page" | "size">
  ): Observable<any> {
    const url: string = `/keywords/lessons/${transcriptId}`;
    return api.get(url, params, this.baseUrl);
  }

  getTranscripts(
    transcriptId: string,
    params: Omit<QueryParams, "page" | "size">
  ): Observable<any> {
    const url: string = `/transcripttime/${transcriptId}`;
    return api.get(url, params, this.baseUrl);
  }

  getKeywordsByObjective(objectiveId: string): Observable<BlackListKeywords[]> {
    const url: string = `/keywords/learning-objective/${objectiveId}`;
    return api.get(url);
  }

  addKeywordsToBlacklist(data: {
    keywords: BlackListKeywords[];
  }): Observable<BlackListKeywords[] | void> {
    const url: string = `/keyword/eval`;
    return api.patch(url, data, {}, this.baseUrl);
  }
}
